import React from 'react';
import { Placement } from 'swag-client-common/constants';
import { FILTER_NAMES } from 'swag-common/constants/product.constants';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import InfoIcon from 'swag-client-common/components/icons/info-icon';
import classes from './info-tooltip.scss';
const tooltipStyles = {
  popper: classes.tooltipPopper,
  tooltip: classes.tooltipRoot
};
const getTooltipItems = ({
  isAvailableSuperSpeed
}) => {
  return {
    [FILTER_NAMES.BOX_AND_INVENTORY]: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: classes.bold
    }, "Inventory:"), " Products we can store & distribute from our warehouse"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: classes.bold
    }, "Box:"), " Products eligible to be added to a swag box"), isAvailableSuperSpeed && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: classes.bold
    }, "Super Speed:"), " Products that can be produced & added to a box in 15 business days or less"))
  };
};
export const InfoTooltip = ({
  filterId,
  settings
}) => {
  const tooltipItems = getTooltipItems(settings);
  return tooltipItems[filterId] ? /*#__PURE__*/React.createElement(Tooltip, {
    classes: tooltipStyles,
    title: tooltipItems[filterId],
    placement: Placement.RIGHT,
    mode: "light"
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    className: classes.infoButton
  })) : null;
};